/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { DepartmentsService } from './services/departments.service';
import { LocalStorageService } from './services/localstorage.service';
@Injectable({
  providedIn: 'root'
})
export class HomeService {
  isdisplybrandpopup = false;
  howitworksteps: any[]=[
    {
      id:1,
      title:'Create your budget',
       msgTitle:'Explore interior products',
       msg:'Discover new era of products from top brands for every space of your interior project, and easily generate your bill of materials with just a few clicks.',
      imageUrl:'assets/images/how-it-work/st1.webp',
    }, {
      id:2,
      title:'Shortlist product',
      // msgTitle:'Ease of Buying',
      msgTitle:'Compare offers & buy direct',
      msg:'Compare price offers from multiple brand sellers and negotiate the best deals online. Enjoy your product collection at brand experience centers and partner showrooms while sourcing products offline hassle-free',
      imageUrl:'assets/images/how-it-work/st2.webp',
    },{
      id:3,
      title:'Connect nearest dealers',
      msgTitle:'Cashback & Loyalty',
      msg:'Earn cashback on every purchase at designated brand showrooms. Benefit from an exclusive loyalty program tailored for influencers such as interior professionals and contractors ',
      imageUrl:'assets/images/how-it-work/st3.webp',
    },

  ];
  activeBudgetSec: any;
  minval!: number;
  maxval!: number;
  submitted = false;
  inline_loader = false;
  isAreaNull: any;
  htype: any;
  gustProjectData: any;
  counter= 0;
  constructor(public _ds:DepartmentsService,private localStorageService: LocalStorageService) { 
    this.activeBudgetSec = JSON.parse(localStorageService.getItem("activeBudgetSec") || '{}');
   
    if(!Object.keys(this.activeBudgetSec).length){
      this.activeBudgetSec = "slHType";
    }
  }
  onHouseType(val1:any){
    this.htype=val1;
    this.gustProjectData ={
      houseType:this.htype
    }
  
    this.localStorageService.setItem('gustProjectData', JSON.stringify(this.gustProjectData));
    this.activeBudgetSec='slSpace';
    this.counter++;
  }
  getStart(info_data:any) {
   this.gustProjectData.area =info_data.area;
   this.gustProjectData.home_type =info_data.home_type;
   this.gustProjectData.area_unit = 'sqft'
   this.activeBudgetSec='slCity';
   this.counter++;

    this.updatedGustProjectData()
  }

  updatedGustProjectData() {
    this.localStorageService.setItem('gustProjectData', JSON.stringify(this.gustProjectData));
  }

  onBack(){
    if(this.activeBudgetSec=='slSpace'){
      this.activeBudgetSec='slHType';
      this.counter--;
    }else if(this.activeBudgetSec=='slArea'){
      this.activeBudgetSec='slSpace';
      this.counter--;
    }else if(this.activeBudgetSec=='slCity'){
      this.activeBudgetSec='slArea';
      this.counter--;
    }else{
      this.activeBudgetSec='slHType';
    }
   
  }

}
